import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const DirectionUnified = (props: SvgProps) => (
  <Svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="10" height="1" rx="0.5" fill="#64748B" />
    <rect x="1.5" y="7.5" width="9" height="3" rx="0.5" stroke="#64748B" />
    <rect x="1.5" y="3.5" width="9" height="2" rx="0.5" stroke="#64748B" />
  </Svg>
);

export default DirectionUnified;
